import { useEffect } from 'react';
import { useAuthStore } from '../store';
import authService from '../services/authService';

/**
 * Hook to initialize authentication state on app load
 * This should be used at the root level of the application
 */
export const useAuthStoreInitializer = () => {
  const { fetchCurrentUser, isAuthenticated } = useAuthStore();
  
  useEffect(() => {
    // Check if there's a token in storage
    if (authService.isAuthenticated() && !isAuthenticated) {
      // Check if we already have cached user data before fetching
      const cachedUser = authService.getCachedUserData();
      
      if (cachedUser && cachedUser._id) {
        console.log("AUTH INITIALIZER: Using cached user data instead of fetching:", cachedUser._id);
        // Fetch will use the cached data due to the implementation of authService.getCurrentUser
      } else {
        console.log("AUTH INITIALIZER: No cached user data available, initiating fetch");
      }
      
      // Fetch the user data if we have a token but no user data
      fetchCurrentUser();
    }
  }, [fetchCurrentUser, isAuthenticated]);
  
  return null;
};

export default useAuthStoreInitializer; 